var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiPeopleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_233_6625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2988 115.705C58.2988 115.705 50.0979 115.705 50.0979 107.504C50.0979 99.3036 58.2988 74.7009 91.1024 74.7009C123.906 74.7009 132.107 99.3036 132.107 107.504C132.107 115.705 123.906 115.705 123.906 115.705H58.2988ZM91.1024 66.5C97.6274 66.5 103.885 63.908 108.499 59.2941C113.113 54.6802 115.705 48.4224 115.705 41.8974C115.705 35.3723 113.113 29.1145 108.499 24.5006C103.885 19.8867 97.6274 17.2947 91.1024 17.2947C84.5774 17.2947 78.3196 19.8867 73.7057 24.5006C69.0918 29.1145 66.4997 35.3723 66.4997 41.8974C66.4997 48.4224 69.0918 54.6802 73.7057 59.2941C78.3196 63.908 84.5774 66.5 91.1024 66.5ZM43.6684 115.705C42.4533 113.145 41.847 110.338 41.897 107.504C41.897 96.3923 47.4736 84.952 57.774 76.9972C52.6335 75.4098 47.2766 74.635 41.897 74.7009C9.09347 74.7009 0.892578 99.3036 0.892578 107.504C0.892578 115.705 9.09347 115.705 9.09347 115.705H43.6684ZM37.7966 66.5C43.2341 66.5 48.4489 64.34 52.2939 60.4951C56.1388 56.6502 58.2988 51.4353 58.2988 45.9978C58.2988 40.5603 56.1388 35.3454 52.2939 31.5005C48.4489 27.6556 43.2341 25.4956 37.7966 25.4956C32.3591 25.4956 27.1442 27.6556 23.2993 31.5005C19.4544 35.3454 17.2944 40.5603 17.2944 45.9978C17.2944 51.4353 19.4544 56.6502 23.2993 60.4951C27.1442 64.34 32.3591 66.5 37.7966 66.5Z",
    fill: "#D96578"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_233_6625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131.214,
    height: 131.214,
    fill: "white",
    transform: "translate(0.892578 0.892822)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiPeopleFill);
export default __webpack_public_path__ + "static/media/bi_people-fill.033f9ead72f04789d442b8d4bdf119d2.svg";
export { ForwardRef as ReactComponent };